import { UsePostParams } from '../../../../api';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { httpPost } from '../../../utils';
import { UploadCsvType } from '../../components/UpdateUsersAndTokensPopup';
import { useCallback } from 'react';

interface UploadCsvFileDetails {
    file: FormData;
}

export type UseUploadCsvParams = UsePostParams<UploadCsvFileDetails, { type: UploadCsvType }>;

export const useUploadCsvFile = (params: UseUploadCsvParams) => {
    const uploadUserReqUrl = `${USER_MANAGEMENT_BASE_URL}/uploadProtectedUsersFile`;
    const uploadToken2ReqUrl = `${USER_MANAGEMENT_BASE_URL}/uploadToken2File`;

    const uploadCsv = useCallback(
        async (fileData: FormData, type: UploadCsvType) => {
            const reqUrl = type === 'user' ? uploadUserReqUrl : uploadToken2ReqUrl;
            try {
                await httpPost(reqUrl, fileData);
                params.onSuccess?.({ type });
            } catch (err) {
                params.onError?.(err);
            }
        },
        [uploadUserReqUrl, uploadToken2ReqUrl, params]
    );

    return {
        uploadCsv
    };
};
